export function pointsAsFeatureCollection(points: GeoJSON.Feature<GeoJSON.Point>[]): GeoJSON.FeatureCollection<GeoJSON.Point> {
  return {
    type: 'FeatureCollection',
    features: points
  };
}
